import React, { createContext, useState } from "react";

import { initalData } from "../InitialStates";
import type {
  contextDataProps,
  contextProps,
} from "../../../../types/globalState";
export const GlobalDataContext = createContext<contextDataProps>(initalData);
function GlobalDataProvider({ children }: contextProps) {
  const [loader, setLoader] = useState<boolean>(true);

  return (
    <GlobalDataContext.Provider
      value={{
        loader,
        setLoader,
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
}

export default GlobalDataProvider;
